<script>
    import { link } from "svelte-routing";
    import { getLocalizedField } from "../../common/lang";

    export let page;
    export let active = true;
</script>

<a use:link href={active ? `/about/${page.uid}` : null}>
    <div class="w-full  text-blue-500">
        <h2 class="text-2xl">{getLocalizedField(page.title)}</h2>
    </div>
</a>
<div class="px-4 flex">
    <span class="bg-gray-400 mx-16 w-full h-px mt-2" />
</div>
